
const checkValidEmail = (str) => {
    const regex = /^[-\w.]+@([\w-]+\.)+[-\w]{2,4}$/;
    const matches = str.match(regex);
    return !!matches
}

const checkValidName = (str) => {
    const regex = /^([A-Za-zàáâäãåąčćęèéêëėįìíîïłńòóôöõøùúûüųūÿýżźñçčšžÀÁÂÄÃÅĄĆČĖĘÈÉÊËÌÍÎÏĮŁŃÒÓÔÖÕØÙÚÛÜŲŪŸÝŻŹÑßÇŒÆČŠŽ∂ð]{2,100})((\s)([A-Za-zA-ZàáâäãåąčćęèéêëėįìíîïłńòóôöõøùúûüųūÿýżźñçčšžÀÁÂÄÃÅĄĆČĖĘÈÉÊËÌÍÎÏĮŁŃÒÓÔÖÕØÙÚÛÜŲŪŸÝŻŹÑßÇŒÆČŠŽ∂ð'\-.]{2,100}))*$/;
    const matches = str.match(regex);
    return !!matches
}

const checkValidPassword = (str) => {
    return (
        /^(?=.*[a-z])/.test(str) // has lowercase characters
        && /^(?=.*[A-Z])/.test(str) // has uppercase characters
        && /^(?=.*\d)/.test(str) // has number
        && /^(?=.*[@'"`$+!~%\-*?&.,;:_(){}[\]<>=#^|/\\])/.test(str) // has special character
        && /^[A-Za-z\d@'"`$+!~%\-*?&.,;:_(){}[\]<>=#^|/\\]{8,}$/.test(str) // has 8 of the characters above
    )
}

export {
    checkValidEmail,
    checkValidName,
    checkValidPassword
}
